export enum publicLicenseSearchParams {
  licNo = 'licNo',
  firstName = 'firstName',
  lastName = 'lastName',
  vesselName = 'vesselName'
}
